import { createApp } from './app';
import { registerServiceWorker } from './pwa/register';
import './style.css';
import { installTestingHooks } from './testing/hooks';

const root = document.querySelector<HTMLElement>('#app');
if (!root) {
  throw new Error('Élément racine #app introuvable dans index.html');
}

const app = createApp(root);
app.start();

// PWA (concept §5.2) : manifeste + service worker rendent le jeu installable
// sur un téléphone, en plein écran et en orientation paysage.
registerServiceWorker();

// Remplacé par une constante littérale au build : la branche (et le module
// ./testing/hooks) disparaît du bundle de production (spec §9).
if (import.meta.env.VITE_E2E === '1') {
  installTestingHooks(app);
}
